//////////////////////////////////////////////////////////
//                                                      //   
//  PARA FRANQUEADOS:                                   //   
//                                                      //   
//  APARECE COMO O CARD DE PREÇO E FOTO  DOS            //
//  CARDS DE PRODUTO NA PÁGINA DE INTERESSES            //   
//                                                      //   
//  FUNCIONALIDADE: MOSTRAR CARD DOS PRODUTOS           //    
//                                                      //   
//////////////////////////////////////////////////////////    



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/pages/interesses.js                                //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


import MockPictureFranqueado from  './mock_picture_franqueado';

import '../assets/css/local/header.css';


function PrecoPictureFranqueado(props) {

  // OS COMPONENTES DA PÁGINA SÃO (NA ORDEM QUE APARECEM):
    // 'MockPictureFranqueado' -> PARTE DA FOTO NO CARD DOS PRODUTOS QUE APARECEM NAS PÁGINAS DE PEDIDO

  return (
    <div class="mb-5">

      <div class='px-1 border mx-2 produto-card-franqueado mb-0'>
        <div class="center preco_carrinho mw-picture titulo-card">
          {props.dsc}
        </div>

        <MockPictureFranqueado props={props}/>
      </div>

    </div>
  );
 }

  export default PrecoPictureFranqueado;
  

 